import BattleFooter from './BattleFooter';

export default BattleFooter;
